/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrganizationStaffListSchema } from './OrganizationStaffListSchema';
import {
    OrganizationStaffListSchemaFromJSON,
    OrganizationStaffListSchemaFromJSONTyped,
    OrganizationStaffListSchemaToJSON,
} from './OrganizationStaffListSchema';

/**
 * 
 * @export
 * @interface PagedOrganizationStaffListSchema
 */
export interface PagedOrganizationStaffListSchema {
    /**
     * 
     * @type {Array<OrganizationStaffListSchema>}
     * @memberof PagedOrganizationStaffListSchema
     */
    items: Array<OrganizationStaffListSchema>;
    /**
     * 
     * @type {number}
     * @memberof PagedOrganizationStaffListSchema
     */
    count: number;
}

/**
 * Check if a given object implements the PagedOrganizationStaffListSchema interface.
 */
export function instanceOfPagedOrganizationStaffListSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function PagedOrganizationStaffListSchemaFromJSON(json: any): PagedOrganizationStaffListSchema {
    return PagedOrganizationStaffListSchemaFromJSONTyped(json, false);
}

export function PagedOrganizationStaffListSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedOrganizationStaffListSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(OrganizationStaffListSchemaFromJSON)),
        'count': json['count'],
    };
}

export function PagedOrganizationStaffListSchemaToJSON(value?: PagedOrganizationStaffListSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(OrganizationStaffListSchemaToJSON)),
        'count': value.count,
    };
}

